module.exports = __webpack_public_path__ + "img/Chan.e333b318.jpg";